/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestimonialContent } from '../../models/testimonial-content';

export interface ApiMasterTestimonialContentGetByIdGet$Params {
  id?: string;
}

export function apiMasterTestimonialContentGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterTestimonialContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TestimonialContent>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTestimonialContentGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestimonialContent>;
    })
  );
}

apiMasterTestimonialContentGetByIdGet.PATH = '/api/Master/TestimonialContent/GetById';
